
<div class="col-xl-12 no-padding">
    <div class="row small-section-content">

        <div class="col-md-2 col-sm-6 col-xs-12 no-padding">
            <div tooltip="Open Cases" class="hbgPortalGreen" style="">
                <!--<div class="panel-body hbgPortalGreen" style="padding: 20px;">-->
                <div class="text-center">
                    <p class="text-small caseFont" style="margin: 0px;">
                        {{casesSummary.open}}
                    </p>
                    <small>
                        OPEN
                    </small>
                </div>
                <!--</div>-->
            </div>
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 no-padding">
            <div tooltip="Open Cases" class="hbgPortalWhite" style="">
                <!--<div class="panel-body hbgPortalGreen" style="padding: 20px;">-->
                <div class="text-center">
                    <p class="text-small caseFont" style="margin: 0px;">
                        {{casesSummary.escalated}}
                    </p>
                    <small>
                        ESCALATED
                    </small>
                </div>
                <!--</div>-->
            </div>
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 no-padding">
            <div tooltip="Open Cases" class="hbgPortalGrey" style="">
                <!--<div class="panel-body hbgPortalGreen" style="padding: 20px;">-->
                <div class="text-center">
                    <p class="text-small caseFont" style="margin: 0px;">
                        {{casesSummary.onhold}}
                    </p>
                    <small>
                        ON-HOLD
                    </small>
                </div>
                <!--</div>-->
            </div>
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 no-padding">
            <div tooltip="Open Cases" class="hpanel hbgPortalDisabled" style="">
                <!--<div class="panel-body hbgPortalGreen" style="padding: 20px;">-->
                <div class="text-center">
                    <p class="text-small caseFont" style="margin: 0px;">
                        {{casesSummary.closed}}
                    </p>
                    <small>
                        CLOSED
                    </small>
                </div>
                <!--</div>-->
            </div>
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12 no-padding">
            <div tooltip="Open Cases" class="hpanel hbgPortalLightGreen" style="">
                <!--<div class="panel-body hbgPortalGreen" style="padding: 20px;">-->
                <div class="text-center">
                    <p class="text-small caseFont" style="margin: 0px;">
                        {{(casesSummary.closed +  casesSummary.open + casesSummary.onhold + casesSummary.escalated)}}
                    </p>
                    <small>
                        TOTAL CASES
                    </small>
                </div>
                <!--</div>-->
            </div>
        </div>


    </div>
</div>
